var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-8 px-5"},[_c('ManutenzioneGestioneSediFornitori')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }